import { InjectionToken } from '@angular/core';
import { LoggerConfig } from '../interfaces/logger.interface';

export const LOGGER_CONFIG = new InjectionToken<LoggerConfig>('LOGGER_CONFIG');